import { formatRecursive as s } from "./format.mjs";
function u(r) {
  return s(
    r,
    (t) => typeof t == "string" ? t : `${t}px`
  );
}
function f(r, t) {
  return r.replace(t, "");
}
function a(r, t) {
  const e = { ...r };
  return Object.entries(r).forEach(([n, o]) => {
    const i = n.replace(",", ".");
    if (n.startsWith(t)) {
      const c = f(i, t);
      e[c] = o;
    }
    e[i] = o;
  }), delete e[0], e;
}
function g(r) {
  const t = {};
  return Object.entries(r).forEach(([e, n]) => {
    typeof n == "string" && (t[e] = n.replace(",", ".")), typeof n == "number" && (t[e] = e);
  }), t;
}
const m = {
  Medium: 500,
  Light: 300,
  Regular: 400,
  "Semi Bold": 600
};
function h(r) {
  const t = {};
  return Object.entries(r).forEach(([e, n]) => {
    t[e] = m[n] || n;
  }), t;
}
export {
  u as pixify,
  f as removePrefix,
  h as transformFontWeight,
  g as transformSemanticToken,
  a as transformSpacings
};
